export function addLanguage(
  language: unknown,
  responseId: string,
  greetingId: string
): Record<string, unknown> {
  return {
    type: "ADD_LANGUAGE_TO_GREETING",
    language,
    greetingId
  };
}
